//overlay.vue


<template>
  <div>
    <!-- Live region: must stay in DOM so content *change* is announced when menu opens -->
    <span class="screen-reader-only" aria-live="assertive" aria-atomic="true">{{ state ? 'Navigation menu open' : '' }}</span>
    <transition name="overlay" :duration="{ enter: 500, leave: 800 }">
  <nav class="overlay" v-show='state' @click.self='close' aria-label="Navigation menu">
    <transition name="links" :duration="{ enter: 1500, leave: 800 }">
      <div class="overlay_links">
        <social class="top-caption"/>
        <router-link to="/mixology" target="blank">mixology</router-link>
        <a href="https://contact.pepsico.com/bubly/" target="blank">contact us</a>
        <a href="#"
            class="buynow"
            v-on:click="destiniOverlayIframe"
            @keydown.tab.prevent="gotoCloseButton"  
        >
          buy now
        </a>
        <div class="destinilocatordiv menu_destini">
        </div>
      </div>
    </transition>
  </nav>
    </transition>
  </div>
</template>

<script>
  import Social from '@/components/common/Social';

  export default {
    name: 'overlay',
    data(){
      return {
        retailersVisible: false,

      }
    },
    props: {
      state: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      close() {
        console.log('close');
        console.log("hat")
        if (window.innerWidth > 767) this.$emit('close');

      },
      gotoCloseButton() {
        const closeBtn = document.querySelector(".bubly-hamburger")
        closeBtn.focus()
      },
      toggleRetailers(e){
        e.preventDefault();
        console.log("hat")
        this.retailersVisible = !this.retailersVisible;
      },
      locatorTest: (e) => {
        // const container = e.target.getAttribute("data-destini-container");
        // const association = e.target.getAttribute("data-destini-association");
        // destini.init(container);
        // destini.loadWidget(association);
      },
      closeMenu() {
      },
      destiniOverlayIframe(e) {
        const el = document.createElement("div");
        el.setAttribute("id", "destini_container")
        el.setAttribute("class", "destini-locators-all-products")
        document.querySelector(".menu_destini").appendChild(el)

        loadIframe();
        document.querySelector("iframe#destini").style.height = "1370px"
      }
    },
    components: {
      Social,
    },
  };
</script>

<style lang='scss' scoped>
  @import './../../variables';

  .overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background-color: $bubly-cyan;
    overflow: auto;

    @include breakpoint('mobileonly') {
      .locator-container {
      width: 80%;
      margin: 0 auto;
      padding-top: 2em;
      }
    }

    .overlay_links {
      position: relative;
      top: 20%;
      left: 0;
      right: 0;
      margin: 0 auto;
      // overflow: auto;
      width: 60%;

      a {
        font-size: rem(31);
        display: block;
        text-align: center;
        padding-top: rem(20);
        padding-bottom: rem(20);

        &.retailer {
          opacity: 0;
          margin-top: 0px;
          padding: 0;
          height: 0;
          transition: all .3s ease-out;
          font-size: 1.6rem;
          color: #eee;
          &.visible {
            opacity: 1;
            margin-top: 0;
            padding: 1.25rem;
            height: 100%;
          }
        }
      }
    }
  }

  .overlay-enter-active, .overlay-leave-active {
    transition: opacity .5s;
  }
  .overlay-enter, .overlay-leave-to {
    opacity: 0;
  }

  .links-enter-active, .links-leave-active {
    transition: transform .3s ease-out;
    transition-delay: .5s;
  }
  .links-enter, .links-leave-to {
    transform: translateY(-100%);
  }


  @include breakpoint('tablet') { 
    .locator-container {
      width: 80%;
      margin: 0 auto;
      padding-top: 2em;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/navigation/Overlay.vue